import { UppFloorPlanVertex } from '../plan/floor-plan-element';
import { floorPlanVertexCenterCm } from './floor-plan-perimeter-vertex-geometry';

/** Group perimeter vertices by {@link UppFloorPlanVertex.polygon}; each group sorted by {@link UppFloorPlanVertex.sort}. */
export function groupPerimeterVerticesByPolygonId(
  vertices: readonly UppFloorPlanVertex[],
): Map<string, UppFloorPlanVertex[]> {
  const m = new Map<string, UppFloorPlanVertex[]>();
  for (const v of vertices) {
    const pid = v.polygon || 'default';
    let arr = m.get(pid);
    if (!arr) {
      arr = [];
      m.set(pid, arr);
    }
    arr.push(v);
  }
  for (const arr of m.values()) {
    arr.sort((a, b) => a.sort - b.sort);
  }
  return m;
}

/** Stable polygon ids for paint order (fills below markers). */
export function sortedPolygonIds(groups: ReadonlyMap<string, unknown>): string[] {
  return [...groups.keys()].sort((a, b) => a.localeCompare(b));
}

/** Polyline points in stage px (x,y pairs) through vertex marker centres. */
export function floorPlanPerimeterChainPointsPx(
  chain: readonly UppFloorPlanVertex[],
  scalePxPerCm: number,
): number[] {
  const pts: number[] = [];
  for (const v of chain) {
    const c = floorPlanVertexCenterCm(v);
    pts.push(c.xCm * scalePxPerCm, c.yCm * scalePxPerCm);
  }
  return pts;
}
